export const SET_MESSAGE_CONCLUSAO = "SET_MESSAGE_CONCLUSAO";
